import _ from 'lodash';
// import update from 'immutability-helper';
import objectAssign from 'object-assign';
import classNames from 'classnames';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { withRouter } from 'react-router';
import * as actions from '../../actions/eventActions';
// import Button from '../../../components/common/Button';
// import { Link } from 'react-router';
// import HeaderImage from '../../../components/common/HeaderImage';
// import RichTextInput from '../../../components/common/RichTextInput';
import TextInput from '../../components/common/TextInput';
import CheckboxInput from '../../components/common/CheckboxInput';
import DateInput from '../../components/common/DateInput';
// import DateTimeInput from '../../../components/common/DateTimeInput';
// import RichTextEditor from 'react-rte';
import FontAwesome from 'react-fontawesome';
// import * as utils from '../../../components/common/utils';
// import toastr from 'toastr';

class ManageTeamMemberCategory extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    this.updateField = this.updateField.bind(this);
    this.updateTimeField = this.updateTimeField.bind(this);
    this.toggle = this.toggle.bind(this);
    this.calcAge = this.calcAge.bind(this);
    this.state = {
      category: props.category,
      errors: props.errors,
      show: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.category, nextProps.category)) {
      this.setState({
        category: nextProps.category,
      });
    }
    if (!_.isEqual(this.props.errors, nextProps.errors)) {
      this.setState({
        errors: nextProps.errors,
      });
    }
  }

  updateField(event) {
    let category = objectAssign({}, this.props.category);
    let value = event.target.type == 'checkbox' ? event.target.checked : (event.target.value || '');
    // Check for destroy
    if (event.target.name == '_destroy' && value == true) {
      category['name'] = 'to-be-destroyed';
      category['price'] = 0;
    }
    category[event.target.name] = value;
    this.props.updateMemberCategory(category, this.props.memberIndex);
  }

  updateTimeField(field, time) {
    let category = objectAssign({}, this.props.category);
    category[field] = time;
    this.props.updateMemberCategory(category, this.props.memberIndex);
  }

  toggle(part) {
    this.setState({
      [part]: !this.state[part]
    });
  }

  calcAge(date, prefix) {
    prefix = prefix || '';
    if (date && this.props.eventDetails.start_date) {
      let fromDate = Date.parse(this.props.eventDetails.start_date);
      let ageDifMs = fromDate - Date.parse(date);
      let ageDate = new Date(ageDifMs); // miliseconds from epoch
      return prefix + Math.abs(ageDate.getUTCFullYear() - 1970) + ' år gammel ved starten av arrangementet';
    } else {
      return null;
    }
  }

  render() {
    let _destroy = this.props.category._destroy ? true : false;
    if (_destroy) {
      return <div className="hidden" />;
    }
    return (
      <div className={classNames('panel', {
          'panel-default': _.isEmpty(this.props.errors),
          'panel-danger': !_.isEmpty(this.props.errors),
        })}>
        <div className="panel-heading"
          onClick={() => {
            this.toggle('show');
          }}>
          {this.props.category.name || 'Ny medlemskategori'}
        </div>
        <div className={classNames('panel-body',
          {'hidden': !this.state.show})}>
          <TextInput
            name="name"
            label="Navn"
            error={this.props.errors.name}
            onChange={this.updateField}
            value={this.props.category.name}
            />
          <TextInput
            name="price"
            label="Pris"
            error={this.props.errors.price}
            helpText="Pris per medlemskategori"
            onChange={this.updateField}
            value={this.props.category.price}
            />
          <TextInput
            name="article_number"
            inputType="number"
            label="Artikkel nummer"
            error={this.props.errors.article_number}
            disabled={this.props.category._destroy}
            onChange={this.updateField}
            value={this.props.category.article_number}
            />
          <TextInput
            name="priority"
            inputType="number"
            label="Prioritering"
            error={this.props.errors.priority}
            disabled={this.props.category._destroy}
            onChange={this.updateField}
            value={this.props.category.priority}
            />
          <div className="row">
            <div className="col-sm-6">
              <TextInput
                name="min_of_category"
                inputType="number"
                label="Minimum antall av kategorien (pr. gruppe)"
                error={this.props.errors.min_of_category}
                disabled={this.props.category._destroy}
                onChange={this.updateField}
                value={this.props.category.min_of_category}
                />
            </div>
            <div className="col-sm-6">
              <TextInput
                name="max_of_category"
                inputType="number"
                label="Maks antall av kategorien (pr. gruppe)"
                error={this.props.errors.max_of_category}
                disabled={this.props.category._destroy}
                onChange={this.updateField}
                value={this.props.category.max_of_category}
                />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <DateInput
                name="max_birthdate"
                label="Øvre aldersgrense (født etter)"
                error={this.props.errors.max_birthdate}
                onChange={this.updateTimeField}
                value={this.props.category.max_birthdate}
                />
              <div className="help-block">
                {this.calcAge(this.props.category.max_birthdate, 'Maks ')}
              </div>
            </div>
            <div className="col-sm-6">
              <DateInput
                name="min_birthdate"
                label="Nedre aldersgrense (født før)"
                error={this.props.errors.min_birthdate}
                onChange={this.updateTimeField}
                value={this.props.category.min_birthdate}
                />
              <div className="help-block">
                {this.calcAge(this.props.category.min_birthdate, 'Minst ')}
              </div>
            </div>
          </div>
          {/*<CheckboxInput
            fieldId={'gather_estimates' + this.props.category.identifier}
            name={'gather_estimates'}
            label="Samle estimater"
            error={this.props.errors.gather_estimates}
            onChange={this.updateField}
            checked={this.props.category.gather_estimates}
            value={'_'+this.props.category.gather_estimates}
            />*/}
          <CheckboxInput
            fieldId={'hidden_category' + this.props.category.identifier}
            name={'hidden_category'}
            label="Skjul kategori"
            error={this.props.errors.hidden_category}
            onChange={this.updateField}
            checked={this.props.category.hidden_category}
            value={'_'+this.props.category.hidden_category}
            />
        </div>
        <div className={classNames('panel-footer',
          {'hidden': !this.state.show})}>
          <label className={'btn btn-danger btn-small' +
            (this.props.category._destroy ? ' active' : '')}>
            <input type="checkbox"
              name="_destroy"
              className="hidden"
              value={_destroy}
              onChange={this.updateField}
              checked={_destroy} />
              <FontAwesome name="trash" />
          </label>
          &emsp;
          <label
            onClick={() => this.props.copyMemberCategory(this.props.categoryIndex, this.props.category)}
            className={'btn btn-default btn-small'}>
              <FontAwesome name="copy" />
          </label>
          <span className="pull-right">
            <button type="button"
              className="btn btn-default"
              onClick={() => {
                this.props.updateMemberPosition(this.props.categoryIndex,
                  this.props.memberIndex,
                  this.props.memberIndex-1);
              }}>
              <FontAwesome name="arrow-up" />
            </button>
            {' '}
            <button type="button"
              className="btn btn-default"
              onClick={() => {
                this.props.updateMemberPosition(this.props.categoryIndex,
                  this.props.memberIndex,
                  this.props.memberIndex+1);
              }}>
              <FontAwesome name="arrow-down" />
            </button>
          </span>
        </div>
      </div>
    );
  }
}

ManageTeamMemberCategory.propTypes = {
  actions: PropTypes.object.isRequired,
  memberIndex: PropTypes.number,
  categoryIndex: PropTypes.number,
  category: PropTypes.object.isRequired,
  eventDetails: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  updateMemberPosition: PropTypes.func.isRequired,
  updateMemberCategory: PropTypes.func.isRequired,
  copyMemberCategory: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    loading: state.events.loading,
    eventDetails: state.events.eventDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageTeamMemberCategory));



/** WEBPACK FOOTER **
 ** ./src/containers/events/ManageTeamMemberCategory.js
 **/